import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "./components/PublicLayout";
import Cover from "./pages/Cover";
import Catalogue from "./pages/Catalogue";
import SeriesDetail from "./pages/SeriesDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { getAdminToken } from "./lib/api";
import { Toaster } from "sonner";

function RequireAdmin({ children }) {
  return getAdminToken() ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Cover />} />
            <Route path="/catalogue" element={<Catalogue />} />
            <Route path="/series/:slug" element={<SeriesDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
